<div
  class="modal"
  tabindex="-1"
  role="dialog"
  aria-hidden="true"
  data-at="modal-business"
>
  <div class="modal__content">
    <div class="modal__content__header">
      <div class="navbar navbar--sub">
        <div class="navbar__section navbar__section--title">
          {{ 'EMAIL_ORGANISATION_KEY' | translate }}
        </div>
        <div class="navbar__section navbar__section--right">
          <gk-help-menu [isSmallIcon]="true" class="tw-mt-2"></gk-help-menu>
          <gk-icon-button icon="close" (buttonClick)="close()"></gk-icon-button>
        </div>
      </div>
    </div>
    <gk-email-share-key-personnel-form
      [sendEmail]="sendEmail"
      (saveForm)="emailExchangeKey()"
    >
    </gk-email-share-key-personnel-form>
  </div>
</div>
